import React from 'react'
import {CircularProgress, Grid, Button, Typography} from '@mui/material'
import {makeStyles} from '@oc/styles'

const useStyles = makeStyles({
    root: {
        position: 'relative',
        height: '100%',
        width: '100%'
    },
    viewLoader: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 1000,
        background: 'rgba(255, 255, 255, 0.5)'
    },
    errorGrid: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 1000,
        background: 'rgba(255, 255, 255, 0.5)',
        border: '1px solid red',
        color: 'red'
    }
})

interface LoadableComponentProps {
    children?: React.ReactNode

    isLoading?: boolean
    errorMessage?: string
    setErrorMessage?: (value: string) => void
    clearErrorMessage?: () => void
}

export function LoadableComponent(props: LoadableComponentProps) {
    const {children, errorMessage, setErrorMessage, clearErrorMessage, isLoading} = props
    const {classes} = useStyles()

    const clear = React.useCallback(() => {
        if (setErrorMessage) {
            setErrorMessage('')
        } else if (clearErrorMessage) {
            clearErrorMessage()
        }
    }, [setErrorMessage, clearErrorMessage])

    return (
        <div className={classes.root}>
            {children}
            {isLoading ? (
                <Grid className={classes.viewLoader} container justifyContent="center" alignItems="center">
                    <CircularProgress />
                </Grid>
            ) : errorMessage && (setErrorMessage || clearErrorMessage) ? (
                <Grid
                    className={classes.errorGrid}
                    container
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                >
                    <Typography variant="h4">{errorMessage}</Typography>
                    <Button onClick={clear}>Dismiss</Button>
                </Grid>
            ) : null}
        </div>
    )
}
